import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks/useAction';
import { fetchLead as fetchLeadAction } from 'containers/Leads/Lead/actions';
import { getLeadCustomPreferences as getLeadCustomPreferencesAction } from 'containers/Leads/actions';
import ArchiveModal from 'pages/Leads/Leads.ArchiveModal';

import './styles.scss';

const getPreferencesByType = (preferences = [], type, message) => {
  const filteredCustomPreferences = preferences
    .filter((pref) => pref.kind === type && pref.visibility)
    .map((pref) => {
      const value = pref.id;
      const label = pref.name;
      return {
        value,
        label,
      };
    });
  filteredCustomPreferences.unshift({
    value: -1,
    label: message,
  });

  return filteredCustomPreferences;
};

/**
 * @param {object} props
 * @param {number} props.orgId
 * @param {number} props.leadId
 * @param {boolean} props.archiveLeadOpened
 * @param {() => void} props.onArchive
 * @param {() => void} props.onClose
 */
const LeadArchiveModal = ({
  orgId,
  leadId,
  archiveLeadOpened,
  onArchive,
  onClose,
}) => {
  const leadsById = useSelector((state) => state.leads.leadsById || {});
  const leadData = leadsById[leadId];

  const {
    lead,
    leadCustomStatuses: customStatuses = [],
    customPreferences,
  } = leadData || {};

  const lostReasons = useMemo(() => {
    const reasons = getPreferencesByType(
      customPreferences,
      'reason-for-not-booking',
    );
    // Modal expects different object shape.
    return reasons.map((reason) => ({ id: reason.value, name: reason.label }));
  }, [customPreferences]);

  const lostStatus = useMemo(() => customStatuses.find((status) => status.name === 'Lost'), [customStatuses]);

  const fetchLead = useAction(fetchLeadAction);
  const getLeadCustomPreferences = useAction(getLeadCustomPreferencesAction);

  useEffect(() => {
    if (!archiveLeadOpened || !orgId || !leadId) return;
    fetchLead({ orgId, leadId });
    getLeadCustomPreferences();
  }, [archiveLeadOpened, orgId, leadId]);

  return (
    <ArchiveModal
      leadId={leadId}
      lostReasons={lostReasons}
      lostStatus={lostStatus}
      active={lead?.leadCustomStatusId}
      archiveOpened={archiveLeadOpened}
      setArchiveOpened={(isOpen) => {
        if (!isOpen) onClose();
      }}
      onArchive={onArchive}
    />
  );
};

export default LeadArchiveModal;
